module.exports = __webpack_public_path__ + "assets/img/virtue_icon1.7dff5348.svg";